module.exports = __webpack_public_path__ + "static/media/size4.84a5d5a4.png";